import { useNavigate } from "react-router-dom";
import { FiFileText, FiDollarSign, FiCreditCard } from "react-icons/fi";

const financeOptions = [
  { name: "Receivables", path: "/client/receivables", icon: FiDollarSign, color: "bg-brand-50 text-brand-600",   border: "border-brand-100"   },
  { name: "Invoices",    path: "/client/invoices",    icon: FiFileText,   color: "bg-teal-50 text-teal-600",     border: "border-teal-100"    },
  { name: "Payments",    path: "/client/payments",    icon: FiCreditCard, color: "bg-green-50 text-green-600",   border: "border-green-100"   },
];

// Picker for the client money modules, laid out like the System Values page.
const FinancesPage = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-[22px] font-semibold tracking-tight text-gray-900">Finances</h1>
        <p className="mt-1 text-sm text-gray-500">
          Track what clients owe, the invoices you send them and the payments you receive.
        </p>
      </div>

      <div className="space-y-3">
        <div className="flex items-center gap-2">
          <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-widest">Client finances</h2>
          <div className="flex-1 h-px bg-gray-200" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {financeOptions.map((opt) => {
            const Icon = opt.icon;
            return (
              <button
                key={opt.name}
                onClick={() => navigate(opt.path)}
                className={`group flex items-center gap-3 bg-white border ${opt.border} rounded-lg px-4 py-3 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-brand-500`}
              >
                <div className={`inline-flex items-center justify-center w-8 h-8 rounded-md shrink-0 ${opt.color}`}>
                  <Icon size={16} />
                </div>
                <span className="text-sm font-semibold text-gray-800 group-hover:text-brand-600 transition-colors">
                  {opt.name}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FinancesPage;
